import { render, staticRenderFns } from "./ActiveProductMenuWrapper.vue?vue&type=template&id=a9b06e08&scoped=true&"
import script from "./ActiveProductMenuWrapper.vue?vue&type=script&lang=js&"
export * from "./ActiveProductMenuWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ActiveProductMenuWrapper.vue?vue&type=style&index=0&id=a9b06e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b06e08",
  null
  
)

export default component.exports